import { render, staticRenderFns } from "./salaryDetailList.vue?vue&type=template&id=9d2ce5c0&scoped=true"
import script from "./salaryDetailList.vue?vue&type=script&lang=js"
export * from "./salaryDetailList.vue?vue&type=script&lang=js"
import style0 from "./salaryDetailList.vue?vue&type=style&index=0&id=9d2ce5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2ce5c0",
  null
  
)

export default component.exports